export enum LoginState {
	credential = 0,
	schoolSelection = 1,
	sso = 2,
	passwordReset = 3,
	needHelp = 4,
}
